'use client';

import dynamic from 'next/dynamic';
import * as coinsLottieData from '@/assets/lotties/coins.json';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const CoinsLottie = () => {
  return <Lottie animationData={coinsLottieData} loop />;
};
